// extracted by mini-css-extract-plugin
export default {"content":"lab-value-delete_content__1M4uf","buttons":"lab-value-delete_buttons__fAlK6","button":"lab-value-delete_button__LTtY+"};